/* eslint-disable import/no-cycle */
import {decorate, observable} from 'mobx';
import {Api} from '../middleware/api';
import {EntityStore} from './entityStore';
import {KeyPerformanceIndicatorTarget} from '../models/keyPerformanceIndicatorTarget';
import {calculateEndpoint} from '../middleware/endpoints/keyPerformanceIndicatorTarget';

export class KeyPerformanceIndicatorTargetStore extends EntityStore {
  kpiTargets = [];

  constructor(rootStore) {
    super(rootStore, 'kpiTargets', Api.keyPerformanceIndicatorTarget, KeyPerformanceIndicatorTarget);
  }

  getDependencies() {
    return [
      {
        store: this.rootStore.keyPerformanceIndicatorStore,
        modelId: 'keyPerformanceIndicatorId',
      },
      {
        store: this.rootStore.materialStore,
        modelId: 'materialId',
      },
    ];
  }

  calculate(paramOptions = {}) {
    return this.loadAll({...paramOptions, apiEndpoint: calculateEndpoint, raw: true})
      .then((response) => response.data);
  }
}

decorate(KeyPerformanceIndicatorTargetStore, {
  kpiTargets: observable,
});
